// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610021044/js/" + chunkId + "." + {"44":"f1935b96","225":"d874886f","481":"26dc2383","486":"e4c2044a","770":"5f9c36d4"}[chunkId] + ".0.7312502050245611.chunk.js";
};